"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./ImageDisplay.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageDisplay = function ImageDisplay(props) {
  var imageUrl = props.imageUrl,
      editFn = props.editFn,
      removeFn = props.removeFn;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "image-display-and-buttons"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "uploaded-photo",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "photo-edit-buttons"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "photo-edit-button",
    onClick: editFn
  }, "Edit"), /*#__PURE__*/_react.default.createElement("div", {
    className: "photo-remove-button",
    onClick: function onClick() {
      return removeFn(imageUrl);
    }
  }, "Remove")));
};

ImageDisplay.propTypes = {
  imageUrl: _propTypes.default.string,
  editFn: _propTypes.default.func,
  removeFn: _propTypes.default.func
};
var _default = ImageDisplay;
exports.default = _default;